<template>
  <div class="col-12 col-md-5 col-xl-3 circle-graph-col">
    <div class="graph-and-filters">
      <div class="circle-graph-wrapp">
        <div class="circle-graph circle-custom circle-big">
          <svg>
            <g transform="rotate(135 120 120)">
              <circle cx="120" cy="120" r="110" stroke-width="20" stroke-dasharray ="518.2 172.5" fill="none"/>
            </g>
          </svg>
        </div>
        <div v-show="hasIsolation" class="circle-graph circle-custom circle-small">
          <svg>
            <g transform="rotate(135 81 81)">
              <circle cx="81" cy="81" r="71"  stroke-width="20" stroke-dasharray ="334.5 111.3" fill="none" />
            </g>
          </svg>
        </div>
        <div :class="['circle-graph', 'circle-big', 'circle-percent', powerPercent > 0 ? '' : 'opacity']">
          <svg>
            <g transform="rotate(135 120 120)">
              <circle id="circle1" class="circle" cx="120" cy="120" r="110" stroke-width="20" :stroke-dasharray="powerStrokeDasharray" fill="none" stroke="url(#cl1)" />
              <linearGradient id="cl1" gradientUnits="objectBoundingBox" x1="0" y1="0" x2="1" y2="1">
                <stop stop-color="#367cd4"></stop>
                <stop offset="100%" stop-color="#02d0ff"></stop>
              </linearGradient>
            </g>
          </svg>
        </div>
        <div v-show="hasIsolation" :class="['circle-graph', 'circle-small', 'circle-percent', prPercent > 0 ? '' : 'opacity']">
          <svg>
            <g transform="rotate(135 81 81)">
              <circle id="circle2" class="circle" cx="81" cy="81" r="71" stroke-width="20" :stroke-dasharray="prStrokeDasharray" fill="none"  stroke="url(#cl2)" />
              <linearGradient id="cl2" gradientUnits="objectBoundingBox" x1="0" y1="0" x2="1" y2="1">
                <stop stop-color="#7551b5"></stop>
                <stop offset="100%" stop-color="#433b90"></stop>
              </linearGradient>
            </g>
          </svg>
        </div>
        <div v-show="hasIsolation" class="circle-percent-text">{{prPercent}}%</div>
      </div>
      <div class="circle-power-text">
        <p>
          <span class="spacer">{{ totalPower | round }} kW <span class="percent">max</span></span>
          <span>{{power | round}} kW <span class="percent">({{powerPercent}} %)</span></span>
        </p>
        <div v-show="restriction !== null && restriction < totalPower" class="power-restriction">
          <img src="../../assets/images/power_warning.png" alt="Warning">
          <span class="power">{{ restriction }} kW</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import object from 'lodash'
import data from '@/api/data'
import station from '@/api/station'

export default {
  name: 'PowerRate',
  components: {

  },
  data () {
    return {
      unsubscribe: null,
      power: 0,
      powerPercent: 0,
      prPercent: 0,
      hasIsolation: false,
      polling: null,
      restrictionPolling: null,
      restriction: null
    }
  },
  filters: {
    round (val) {
      return Math.round(val)
    }
  },
  methods: {
    strokeDasharray (percent, r) {
      let firstSet = 0
      let secondSet = 0

      if (percent > 0) {
        const percentCircle = (100 / percent) * (100 / 75)
        const radius = Math.PI * 2 * r
        firstSet = radius / percentCircle
        secondSet = radius - firstSet
      }

      return `${firstSet} ${secondSet}`
    },
    getProductionRatio () {
      data.productionRatio(this.$route.params.id).then(r => {
        this.prPercent = Math.round(r.data.pr * 10000) / 100
      })
    },
    getRestriction () {
      station.findStationRestriction(this.$route.params.id).then(r => {
        this.restriction = r.data.value
      })
    }
  },
  computed: {
    powerStrokeDasharray () {
      return this.strokeDasharray(this.powerPercent, 110)
    },
    prStrokeDasharray () {
      return this.strokeDasharray(this.prPercent, 71)
    },
    totalPower () {
      return Number(this.$store.getters['station/station'].power.replace(',', '.')) * 1000
    }
  },
  created () {
    this.getProductionRatio()
    this.polling = setInterval(this.getProductionRatio, 1000 * 60 * 5)

    this.unsubscribe = this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'station/FETCH_LAST_DATA') {
        const station = this.$store.getters['station/station']
        this.hasIsolation = station.schema.insolationSensor !== null

        let power = 0

        station.schema.powerLines.forEach(line => {
          power += Number(object.get(mutation.payload, [line.deviceId, line.activePowerParameter]))
        })

        const powerPercent = Math.round((power / (station.schema.totalPower * 1000)) * 100 * 100) / 100
        this.power = power

        if (powerPercent > 0 && powerPercent <= 100) {
          this.powerPercent = powerPercent
        } else {
          this.powerPercent = 0
        }
      }
    })

    this.getRestriction()
    this.restrictionPolling = setInterval(this.getRestriction, 1000 * 60 * 3)
  },
  beforeDestroy () {
    this.unsubscribe()
    clearInterval(this.polling)
    clearInterval(this.restrictionPolling)
  }
}
</script>
